import { jsx as _jsx } from "react/jsx-runtime";
import useIntegralPath from '../../hooks/useIntegralPath';
function RangeIntegral({ range }) {
    const path = useIntegralPath(range);
    return (_jsx("path", { className: "line", stroke: "black", strokeWidth: "1", fill: "none", d: path }));
}
export default RangeIntegral;
